import React from 'react';
import { Toaster, ToastBar, resolveValue } from 'react-hot-toast';
import type { Toast } from 'react-hot-toast';

// Уведомления-тосты по макету Figma:
// белая карточка 320px, border #E2E4E9, radius 16, padding 12, gap 16,
// иконка circle-* 24px, текст Inter 16/24 weight 500, -0.02em, #161922.

const SuccessIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 512 512" fill="none" style={{ flex: 'none' }} aria-hidden>
    <path
      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
      fill="#05DF72"
    />
  </svg>
);

const ErrorIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 512 512" fill="none" style={{ flex: 'none' }} aria-hidden>
    <path
      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112zm-24 200a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
      fill="#FB3748"
    />
  </svg>
);

const LoadingIcon: React.FC = () => (
  <span
    style={{
      flex: 'none',
      width: 20,
      height: 20,
      margin: 2,
      borderRadius: '50%',
      border: '2px solid #E2E4E9',
      borderTopColor: '#525866',
      animation: 'app-toast-spin 0.7s linear infinite',
    }}
    aria-hidden
  />
);

const renderIcon = (t: Toast): React.ReactNode => {
  // Кастомная иконка тоста (например toast('...', { icon: '⚠️' })) имеет приоритет.
  if (t.icon !== undefined && t.icon !== null) {
    return (
      <span
        style={{ flex: 'none', display: 'flex', alignItems: 'center', fontSize: 20, lineHeight: '24px' }}
        aria-hidden
      >
        {resolveValue(t.icon, t)}
      </span>
    );
  }
  if (t.type === 'success') return <SuccessIcon />;
  if (t.type === 'error') return <ErrorIcon />;
  if (t.type === 'loading') return <LoadingIcon />;
  return null;
};

export const AppToaster: React.FC = () => (
  <>
    {/* keyframes для лоадера (тосту нужен только локальный spin) */}
    <style>{'@keyframes app-toast-spin{to{transform:rotate(360deg)}}'}</style>
    <Toaster
      position="top-right"
      gutter={10}
      containerStyle={{ top: 16, right: 16, zIndex: 99999 }}
      toastOptions={{
        duration: 5000,
        error: { duration: 8000 },
      }}
    >
      {(t: Toast) => (
        <ToastBar
          toast={t}
          style={{
            maxWidth: 'none',
            width: 320,
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            gap: 16,
            padding: 12,
            background: '#FFFFFF',
            border: '1px solid #E2E4E9',
            borderRadius: 16,
            boxShadow: 'none',
            color: '#161922',
            fontFamily: "'Inter', sans-serif",
            fontSize: 16,
            lineHeight: '24px',
            fontWeight: 500,
            letterSpacing: '-0.02em',
          }}
        >
          {() => (
            <>
              {renderIcon(t)}
              <span {...t.ariaProps} style={{ flex: 1, margin: 0 }}>
                {resolveValue(t.message, t)}
              </span>
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
  </>
);
